import styled from "@emotion/styled";
import { useRealEstateDetailContext } from "../../context/realestate-details.context";
import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import { formatPhoneNumber } from "@/src-refactor/modules/shared/helpers/format-phone-number.helper";
import MessageIcon from "@icons-rf/property-panel/message-icon.svg?react";
import { Avatar, Grid, IconButton } from "@mui/material";
import { redirectEmail } from "@/src-refactor/modules/shared/helpers/email.helper";
import getInitialsLetter from "@/src-refactor/modules/shared/helpers/first-letter-word.helper";
import useUserIs from "@/src-refactor/modules/shared/hooks/use-useris.hook";
import { useLoggedUser } from "@/shared/store/auth";
import { useMemo } from "react";
import { ERolesCode } from "@/shared/models/enums/roles/roles-code.enum";
import { useNavigate } from "react-router-dom";
import { C_PATH_ROUTES } from "@/src-refactor/modules/shared/model/const/path.const";
import SimpleCard2 from "@/src-refactor/modules/shared/components/SimpleCard2";
import { IconFlagFilled } from "@tabler/icons-react";
import useUserHasPermission from "@/shared/hooks/use-useris.hook";

const OwnersCard = () => {
  const {
    PROPERTY_DETAIL: { owners, agents }
  } = useRealEstateDetailContext();

  const { userIsNot, userIs } = useUserIs();
  const { USER_ROLE } = useUserHasPermission();
  const {
    userLogged: { userData }
  } = useLoggedUser();
  const navigate = useNavigate();

  const show: boolean = useMemo(() => {
    const agent = agents.find(item => item.id === userData?.people_id);
    if (agent) {
      return true;
    }

    if (userIs(ERolesCode.SUPER_ADMIN)) {
      return true;
    }
    const match = owners.filter(item => item.id === userData?.user_id);
    if (match.length > 0) {
      return true;
    }
    return false;
  }, []);

  if (!show) return <></>;

  return (
    <SimpleCard2 showBg={false} title="Propietario/s">
      {owners.map(owner => (
        <Content>
          <Avatar
            sx={{ width: 70, height: 70 }}
            children={owner.name ? getInitialsLetter(owner.name) : undefined}
          />
          <TextContainer>
            <TextSimple
              color="blue"
              size="sub-title"
              weight="bold"
              font="gotham"
              align="center"
              cursor="pointer"
              onClick={() => {
                navigate(C_PATH_ROUTES.OWNERS.DETAIL(owner.id));
              }}
            >
              {owner.name}
              {Boolean(owner?.is_conflictive) && USER_ROLE.IS_ADMINISTRATOR && (
                <IconFlagFilled
                  style={{
                    fill: "#dc1d2d",
                    width: "134x",
                    height: "14px",
                    marginLeft: "5px"
                  }}
                />
              )}
            </TextSimple>

            <CustomDivider />
            <TextSimple color="gray" size="sub-title" align="center" weight="300">
              Propietario
            </TextSimple>

            <TextSimple
              color="blue"
              size="sub-title"
              font="gotham"
              align="center"
              weight="700"
            >
              {formatPhoneNumber(owner.phoneNumber)}
            </TextSimple>
          </TextContainer>

          <Button onClick={() => redirectEmail(owner.email)}>
            <MessageIcon />
          </Button>
        </Content>
      ))}
    </SimpleCard2>
  );
};

export default OwnersCard;

const Content = styled.div`
  display: grid;
  grid-template-columns: 70px 1fr 50px;
  align-items: center;
  justify-content: center;
  * {
    text-align: center;
  }
  margin-bottom: 20px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;

const Button = styled(IconButton)`
  & svg {
    color: var(--color-blue-main);
    width: 20px;
    height: 20px;
  }
`;

const CustomDivider = styled.hr`
  width: 60%;
  background-color: red;
  border: 1px solid red;
  color: red;
  margin-top: 2px;
  margin-bottom: 1px;
`;
